import { formatCount, money } from "@/lib/format";

/** The ceilings past which the calculator hands over to a person. */
export const CeilingSummary = ({ items }) => (
  <div
    data-testid="rate-card-summary"
    className="mt-5 grid grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-4"
  >
    {(items || []).map((item) => (
      <div
        key={item.label}
        className="rounded-lg border border-border bg-[color:var(--tt-surface-2)] px-4 py-3"
      >
        <p className="text-[10px] font-bold uppercase tracking-[0.12em] text-primary">
          {item.label}
        </p>
        <p className="mt-1 font-amount text-lg font-bold text-foreground">
          {item.kind === "money" ? money(item.value) : formatCount(item.value)}
          {item.kind === "count" ? (
            <span className="ml-1 text-xs font-normal text-muted-foreground">/ month</span>
          ) : null}
        </p>
        <p className="mt-1 text-[11px] leading-relaxed text-muted-foreground">{item.help}</p>
      </div>
    ))}
  </div>
);
